/* MXDVS RANDOM PICK: Shopify asset assets/mxdvs-random-pick.js, 28.09.2026
   Size and variant selector plus "View product" for the random pick (slot machine),
   in the empty cart and on the 404 page. Loaded by sections/cart-drawer.liquid, after
   assets/cart-drawer.js, and extends the <mx-slot> element defined there. The 404 page
   uses the same element (<mx-404-slot> in assets/mxdvs-404.js), so both get this.

   - After the spin lands, products with sizes or variants show their options as chips.
     Sold-out options are struck through; picking one option updates what is still
     available in the others.
   - Options with one value (like "Default Title" or a fixed extra) and options with only
     one value left in stock are picked automatically, also after each choice.
   - Choosing the last missing option (for most products: the size) adds it to the cart
     straight away. The + adds too once everything is chosen; pressed earlier, the options
     that still need a choice light up and decode, and the status asks for them.
   - "View product" links to the product page.
   Texts and short size names come from the theme editor (data attributes on the element). */

(function () {
  function install() {
    var MxSlot = customElements.get('mx-slot');
    var M = window.MxCart;
    if (!MxSlot || !M) return false;
    var P = MxSlot.prototype;
    if (P._mxOptions) return true;
    P._mxOptions = true;

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    /* ---------- Short chip names: "2XLarge=2XL, Small=S" ---------- */
    function parseMap(text) {
      return String(text || '')
        .split(',')
        .map(function (s) { return s.split('='); })
        .filter(function (p) { return p.length === 2 && p[0].trim(); })
        .map(function (p) { return [p[0].trim(), p[1].trim()]; })
        // Longest names first, so XLarge is never read as Large
        .sort(function (a, b) { return b[0].length - a[0].length; });
    }

    function shortName(value, map) {
      var out = String(value);
      map.forEach(function (pair) {
        out = out.replace(new RegExp(pair[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), pair[1]);
      });
      return out.replace(/\s*\/\s*/g, '/');
    }

    /* ---------- Options and variants, from /products/[handle].js or products.json ---------- */
    function variantValues(v) {
      if (Array.isArray(v.options)) return v.options;
      return [v.option1, v.option2, v.option3].filter(function (o) { return o != null; });
    }

    function optionsOf(p) {
      var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
      var variants = p.variants || [];
      var count = Math.max(names.length, variants.length ? variantValues(variants[0]).length : 0);
      var list = [];
      for (var k = 0; k < count; k++) {
        var values = [];
        variants.forEach(function (v) {
          var val = variantValues(v)[k];
          if (val != null && values.indexOf(val) === -1) values.push(val);
        });
        list.push({ name: names[k] || 'Option', values: values });
      }
      return list;
    }

    function fits(p, test) {
      return (p.variants || []).some(function (v) {
        if (!v.available) return false;
        var vals = variantValues(v);
        return test.every(function (t, i) { return t == null || t === vals[i]; });
      });
    }

    // Pre-choose options with one value, and options with only one value left in stock
    function preselect(p, opts) {
      var chosen = opts.map(function (o) { return o.values.length === 1 ? o.values[0] : null; });
      var changed = true;
      while (changed) {
        changed = false;
        opts.forEach(function (o, k) {
          if (chosen[k] != null) return;
          var left = o.values.filter(function (val) {
            var test = chosen.slice();
            test[k] = val;
            return fits(p, test);
          });
          if (left.length === 1) {
            chosen[k] = left[0];
            changed = true;
          }
        });
      }
      return chosen;
    }

    function variantFor(p, chosen) {
      if (!p || chosen.some(function (c) { return c == null; })) return null;
      return (p.variants || []).filter(function (v) {
        if (!v.available) return false;
        var vals = variantValues(v);
        return chosen.every(function (c, i) { return c === vals[i]; });
      })[0] || null;
    }

    function optionsHtml(opts, map) {
      var visible = [];
      opts.forEach(function (o, k) {
        if (o.values.length > 1) visible.push(k);
      });
      if (!visible.length) return '';
      return (
        '<div class="mx-slot__opts">' +
        visible
          .map(function (k) {
            var o = opts[k];
            return (
              '<div class="mx-slot__opt" data-index="' + k + '">' +
              (visible.length > 1 ? '<span class="mx-slot__opt-name">' + M.esc(o.name) + '</span>' : '') +
              '<div class="mx-slot__chips" role="radiogroup" aria-label="' + M.esc(o.name) + '">' +
              o.values
                .map(function (val) {
                  return (
                    '<button type="button" class="mx-slot__chip" role="radio" aria-checked="false" data-value="' +
                    M.esc(val) + '" aria-label="' + M.esc(val) + '">' + M.esc(shortName(val, map)) + '</button>'
                  );
                })
                .join('') +
              '</div></div>'
            );
          })
          .join('') +
        '</div>'
      );
    }

    /* ---------- Methods on the random pick element ---------- */

    P.slotMap = function () {
      return parseMap(this.dataset.sizes);
    };

    // Sold-out state per chip, given what is chosen in the other options
    P.refreshChips = function () {
      var p = this.product;
      var chosen = this.chosen || [];
      if (!p) return;
      this.querySelectorAll('.mx-slot__opt').forEach(function (row) {
        var k = +row.dataset.index;
        row.querySelectorAll('.mx-slot__chip').forEach(function (chip) {
          var test = chosen.slice();
          test[k] = chip.dataset.value;
          var ok = fits(p, test);
          chip.disabled = !ok;
          if (!ok && chosen[k] === chip.dataset.value) chosen[k] = null;
          var on = chosen[k] === chip.dataset.value;
          chip.classList.toggle('is-selected', on);
          chip.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      });
    };

    P.pickChip = function (chip) {
      if (this.busy || this.adding || chip.disabled || !this.product) return;
      var k = +chip.closest('.mx-slot__opt').dataset.index;
      var user = (this.userPicked = this.userPicked || {});
      // A chip the page chose for you counts as your pick when you click it, instead of
      // switching it off. A chip you picked yourself switches off on a second click.
      var picked = this.chosen[k] !== chip.dataset.value || !user[k];
      this.chosen[k] = picked ? chip.dataset.value : null;
      if (picked) user[k] = true;
      else delete user[k];
      this.refreshChips();
      // If that leaves only one value in stock in another option, pick it too
      var opts = optionsOf(this.product);
      var self = this;
      opts.forEach(function (o, i) {
        if (self.chosen[i] == null && i !== k) {
          var test = self.chosen.slice();
          var left = o.values.filter(function (val) { test[i] = val; return fits(self.product, test); });
          if (left.length === 1) self.chosen[i] = left[0];
        }
      });
      this.refreshChips();
      var v = variantFor(this.product, this.chosen);
      this.status.innerHTML = v
        ? '&gt; ' + M.esc(shortName(v.title || variantValues(v).join(' / '), this.slotMap()).toLowerCase()) + ' selected'
        : '&gt; match found';

      // Once you have clicked every option that has a choice (for most products: the size),
      // it goes into the cart straight away, no + needed. Options the page filled in for you
      // do not count, so nothing is added that you did not click. The + still adds too.
      var allClicked = opts.every(function (o, i) { return o.values.length < 2 || user[i]; });
      if (picked && v && allClicked) {
        var add = this.querySelector('.mx-rec__add');
        this.adding = true;
        setTimeout(function () { self.adding = false; }, 1500);
        if (add) this.addVariant(v.id, add);
      }
    };

    // + pressed before everything is chosen: those options light up and their sizes decode
    P.nudge = function () {
      var chosen = this.chosen || [];
      var names = [];
      this.querySelectorAll('.mx-slot__opt').forEach(function (row) {
        var k = +row.dataset.index;
        if (chosen[k] != null) return;
        row.classList.remove('is-nudge');
        void row.offsetWidth;
        row.classList.add('is-nudge');
        setTimeout(function () { row.classList.remove('is-nudge'); }, 950);
        row.querySelectorAll('.mx-slot__chip:not(:disabled)').forEach(function (chip) {
          M.decode(chip, chip.textContent, 40, 6);
        });
        names.push(row.querySelector('.mx-slot__chips').getAttribute('aria-label'));
      });
      var text = this.dataset.nudge || '> select [option]';
      this.status.textContent = text.replace('[option]', names.join(' and ').toLowerCase() || 'an option');
    };

    P.add = function (button) {
      var v = variantFor(this.product, this.chosen || []);
      if (!v) {
        this.nudge();
        return;
      }
      this.addVariant(v.id, button);
    };

    // Adds the chosen variant, then rebuilds the drawer from empty to full (no reload).
    // The 404 page overrides this to open the drawer instead.
    P.addVariant = function (variantId, button) {
      var self = this;
      button.disabled = true;
      this.btn.disabled = true;
      this.status.innerHTML = '&gt; adding';
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _source: 'cart_drawer_slot' } }] }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) throw new Error(data.description || '');
            return data;
          });
        })
        .then(function () {
          self.status.innerHTML = '&gt; added to cart';
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'cart_upsell_add_to_cart', upsell_group: 'slot', product_id: variantId });
          setTimeout(M.rebuildFromEmpty, 500);
        })
        .catch(function () {
          self.status.innerHTML = '&gt; could not add, try again';
          button.disabled = false;
          self.btn.disabled = false;
        });
    };

    // The landing card: + on the photo, options and "View product" next to it.
    // No full-card link any more, so the chips can be clicked. Once landed, the photo and
    // the title link to the product page (10.10.2026); the + stays the add button.
    P.card = function (p, final) {
      var img = this.image(p);
      var pic = img ? '<span class="mx-slot__img" style="background-image:url(\'' + M.esc(img) + '\')"></span>' : '';
      var media =
        '<div class="mx-rec__media">' +
        (final && pic ? '<a class="mx-slot__imglink" href="' + M.esc(final.url) + '" tabindex="-1" aria-hidden="true">' + pic + '</a>' : pic) +
        (final ? '<button type="button" class="mx-rec__add" aria-label="Add ' + M.esc(p.title) + ' to cart">+</button>' : '') +
        '</div>';
      var title = final
        ? '<a class="mx-rec__title mx-slot__title" href="' + M.esc(final.url) + '">' + M.esc(p.title) + '</a>'
        : '<p class="mx-rec__title">' + M.esc(p.title) + '</p>';
      return (
        '<div class="mx-slot__card">' + media +
        '<div class="mx-slot__info">' + title +
        '<p class="mx-rec__price">' + (final ? final.price : '') + '</p>' +
        (final ? final.opts + '<a class="mx-slot__view" href="' + M.esc(final.url) + '">' + M.esc(this.dataset.view || '> View product') + '</a>' : '') +
        '</div></div>'
      );
    };

    // quiet = land on a product without the spin (used when "spin on open" is off)
    P.spin = function (quiet) {
      if (this.busy) return;
      this.busy = true;
      this.btn.disabled = true;
      this.status.innerHTML = '&gt; loading';
      this.classList.remove('has-options');
      var self = this;
      var reduce = M.reduced();
      var cfg = M.cfg() || {};

      M.slotPool(this.dataset.skip, this.dataset.count).then(function (pool) {
        if (!pool.length) {
          self.status.innerHTML = '&gt; nothing in stock';
          self.busy = false;
          self.btn.disabled = false;
          return;
        }
        var target;
        do {
          target = pool[Math.floor(Math.random() * pool.length)];
        } while (pool.length > 1 && self.current && target.handle === self.current.handle);

        // Fetch the landing product in the visitor's currency while the reel spins
        var detail = fetch(root() + 'products/' + target.handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });

        var dur = quiet || reduce ? 0 : Math.max(400, parseInt(self.dataset.spin, 10) || 1800);
        var strip = [self.current || pool[Math.floor(Math.random() * pool.length)]];
        for (var i = 0; i < 16; i++) strip.push(pool[Math.floor(Math.random() * pool.length)]);
        strip.push(target);

        var h = self.reel.parentNode.clientHeight || 175;
        self.reel.style.transition = 'none';
        self.reel.style.transform = 'translateY(0)';
        self.reel.innerHTML = strip.map(function (p) { return self.card(p); }).join('');
        self.status.innerHTML = '&gt; spinning';
        void self.reel.offsetWidth;
        if (dur) {
          self.reel.style.transition = 'transform ' + dur + 'ms cubic-bezier(0.12, 0.7, 0.18, 1)';
          self.reel.style.transform = 'translateY(-' + (strip.length - 1) * h + 'px)';
        }

        Promise.all([detail, new Promise(function (res) { setTimeout(res, dur + 30); })]).then(function (out) {
          var p = out[0] || target;
          var price = typeof p.price === 'number' ? M.money(p.price / 100, cfg.currency, true) : '';
          var url = p.url || root() + 'products/' + target.handle;
          var opts = optionsOf(p);

          self.current = target;
          self.product = p;
          self.chosen = preselect(p, opts);
          self.userPicked = {};

          self.reel.style.transition = 'none';
          self.reel.style.transform = 'translateY(0)';
          self.reel.innerHTML = self.card(
            { title: p.title, images: p.images && p.images.length ? [p.images[0]] : target.images },
            { price: price, url: url, opts: optionsHtml(opts, self.slotMap()) }
          );
          self.classList.toggle('has-options', !!self.reel.querySelector('.mx-slot__opts'));
          self.refreshChips();
          self.classList.remove('is-win');
          void self.offsetWidth;
          self.classList.add('is-win');
          self.status.innerHTML = '&gt; match found';
          if (!quiet) {
            self.spins++;
            if (self.countEl) self.countEl.textContent = self.spins + (self.spins === 1 ? ' spin' : ' spins');
          }
          M.decode(self.querySelector('.mx-rec__title'), String(p.title || '').toUpperCase(), 40, 6);
          self.busy = false;
          self.btn.disabled = false;
        });
      });
    };

    // Chip clicks, for every random pick on the page (empty cart and 404)
    document.addEventListener('click', function (event) {
      var chip = event.target.closest && event.target.closest('.mx-slot__chip');
      if (!chip) return;
      var slot = chip.closest('mx-slot, mx-404-slot');
      if (slot && typeof slot.pickChip === 'function') slot.pickChip(chip);
    });

    return true;
  }

  if (!install()) {
    customElements.whenDefined('mx-slot').then(function () {
      // MxCart is created in the same file as <mx-slot>, so it exists by now
      install();
    });
  }
})();
